import DirectoryItem from "../directory-item/directory-item.component";
import { DirectoryContainer } from "./directory.styles";
import Pies from "../../assets/categories/pies.png";
import Muffins from "../../assets/categories/blueberry-muffins-4.png";
import Cakes from "../../assets/categories/cakes.png";
import Cookies from "../../assets/categories/cookies.png";
import Sourdough from "../../assets/categories/sourdough.png";


const categories = [
    {
      id: 1,
      title: "Bread",
      imageUrl: Sourdough,
      route: 'shop/bread'
    },
    {
      id: 2,
      title: "Cookies",
      imageUrl: Cookies,
      route: 'shop/cookies'

    },
    {
      id: 3,
      title: "Pies",
      imageUrl: Pies,
      route: 'shop/pies'
    },
    {
      id: 4,
      title: "Muffins",
      imageUrl: Muffins,
      route: 'shop/muffins'

    },
    {
      id: 5,
      title: "Cakes",
      imageUrl: Cakes,
      route: 'shop/cakes'

    },
  ];
 
const Directory = () => {
  return (
    <DirectoryContainer>
      {categories.map((category) => (
        console.log(category),
        <DirectoryItem key={category.id} category={category} />
      ))}
    </DirectoryContainer>
  );
};
export default Directory;
